// Picking the exclusive "None of the above" option also clears the "Other" free text.
export default (otherSelected = false) => ({
  otherChecked: otherSelected,

  exclusiveChecked(event) {
    if (!event.target.checked) return;

    this.$root.querySelectorAll('input[type="checkbox"]:not([data-exclusive])').forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.clearOther();
  },

  optionChecked(event) {
    if (!event.target.checked) return;

    const exclusiveCheckbox = this.$root.querySelector('input[type="checkbox"][data-exclusive]');
    if (exclusiveCheckbox) exclusiveCheckbox.checked = false;
  },

  otherToggled(event) {
    if (event.target.checked) {
      this.otherChecked = true;
      this.optionChecked(event);
    } else {
      this.clearOther();
    }
  },

  clearOther() {
    this.otherChecked = false;
    if (this.$refs.otherText) this.$refs.otherText.value = '';
  },
});
